import { integrationLoaders } from '../../@integration-loaders/integration-loaders';
import { GlobalImport } from '../../shared/interfaces';

export const loadIntegrations = async (globalImports: GlobalImport[]) => {
    if (!(`mh` in window)) {
        throw new Error(`"loadIntegrations" called too early. "window.mh" not ready yet.`);
    }

    const importing = globalImports.map(async (globalImport) => {
        return integrationLoaders[globalImport](window.mh);
    });

    return Promise.all(importing);
};
